import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'
import { JobSelectors } from '../../../store/job/selectors'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import { JobActions } from '../../../store/job'
import Image from '../../atoms/display/Image'
import Label from '../../atoms/display/Label'
import FileSelectButton from '../../atoms/inputs/FileSelectButton'

export default function LineQRCodeView() {
  const dispatch = useDispatch()
  const job = useSelector(JobSelectors.job)

  const handleSelectLineQRCodeFile = useCallback(
    (files: File[]) => {
      dispatch(JobActions.uploadLineQrCode({ file: files[0] }))
    },
    [dispatch]
  )

  return (
    <FlexColumn>
      <FlexRow align="center">
        <Label text="LINE QRコード" variant="subtitle" />
        <FileSelectButton accepts={['image/*']} disabled={job == null} onSelect={handleSelectLineQRCodeFile}>
          <Label text="LINE QRコードアップロード" variant="caption" />
        </FileSelectButton>
      </FlexRow>
      {job?.lineQrCodeUrl ? <Image url={job?.lineQrCodeUrl} alt="LINE QR Code" width={80} /> : <Label text="未設定" />}
    </FlexColumn>
  )
}
